import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PAY_URL } from "../../../BaseURL";
import toast from "react-hot-toast";

export const getUserAuth = createAsyncThunk('/auth/getUserAuth',
    async (group) => {
        try {
            const myurl = `${PAY_URL}/admin/get-auth-person`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const data = response.data;
            // console.log(data, "getUserAuth response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const getUserAuthSlice = createSlice({
    name: "getUserAuth",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserAuth.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserAuth.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getUserAuth.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getUserAuthSlice.reducer;